import {gtmEvents as bookTestDriveFormActionCreators} from './book-testdrive-duck'
import {gtmEvents as compareToolActionCreators} from './compare-tool-duck'
import {gtmEvents as compareVehicleSelectorActionCreators} from './compare-vehicle-selector-duck'
import {gtmEvents as getInTouchFormActionCreators} from './contact-us-duck'
import {gtmEvents as gtmAccessoryListActionCreators} from './accessory-list-duck'
import {gtmEvents as gtmAccordionActionCreators} from './accordion-duck'
import {gtmEvents as gtmBackgroundImageSelectorActionCreators} from './background-image-selector-duck'
import {gtmEvents as gtmBuildToolActionCreators} from './build-duck'
import {gtmEvents as gtmButtonActionCreators} from './button-duck'
import {gtmEvents as gtmFeatureYoutubeActionCreators} from './feature-youtube-duck'
import {gtmEvents as gtmFindADealerActionCreators} from './map-search-duck'
import {gtmEvents as gtmGlobalFooterActionCreators} from './global-footer-duck'
import {gtmEvents as gtmGlobalNavLinkActionCreators} from './global-nav-duck'
import {gtmEvents as gtmIconToutBlockActionCreators} from './icon-tout-block-duck'
import {gtmEvents as gtmInPageNavigationActionCreators} from './in-page-navigation-duck'
import {gtmEvents as gtmMapCampaignBlockActionCreators} from './map-select-state-duck'
import {gtmEvents as gtmMiniConfiguratorActionCreators} from './mini-configurator-duck'
import {gtmEvents as gtmMyMazdaLoginActionCreators} from './mymazda-login-duck'
import {gtmEvents as gtmMyMazdaSummaryActionCreators} from './mymazda-summary-duck'
import {gtmEvents as gtmOffersActionCreators} from './offers-duck'
import {gtmEvents as gtmOutletStoreActionCreators} from './outlet-store-duck'
import {gtmEvents as gtmOutletStoreEnquiryFormActionCreators} from './outlet-store-enquiry-form-duck'
import {gtmEvents as gtmRecallsActionCreators} from './recalls-block-duck'
import {gtmEvents as gtmRegisterInterestCreators} from './register-interest-duck'
import {gtmEvents as gtmSearchActionCreators} from './search-duck'
import {gtmEvents as imageToutBlockActionCreators} from './image-tout-block-duck'
import {gtmEvents as postcodeActionCreators} from './postcode-popup-duck'
import {gtmEvents as requestServiceFormActionCreators} from './book-service-duck'
import {gtmEvents as wysiwygActionCreators} from './wysiwyg-content-duck'

export default {
  ...bookTestDriveFormActionCreators,
  ...compareToolActionCreators,
  ...compareVehicleSelectorActionCreators,
  ...getInTouchFormActionCreators,
  ...gtmAccessoryListActionCreators,
  ...gtmAccordionActionCreators,
  ...gtmBackgroundImageSelectorActionCreators,
  ...gtmBuildToolActionCreators,
  ...gtmButtonActionCreators,
  ...gtmFeatureYoutubeActionCreators,
  ...gtmFindADealerActionCreators,
  ...gtmGlobalFooterActionCreators,
  ...gtmGlobalNavLinkActionCreators,
  ...gtmIconToutBlockActionCreators,
  ...gtmInPageNavigationActionCreators,
  ...gtmMapCampaignBlockActionCreators,
  ...gtmMiniConfiguratorActionCreators,
  ...gtmMyMazdaLoginActionCreators,
  ...gtmMyMazdaSummaryActionCreators,
  ...gtmOffersActionCreators,
  ...gtmOutletStoreActionCreators,
  ...gtmOutletStoreEnquiryFormActionCreators,
  ...gtmRecallsActionCreators,
  ...gtmRegisterInterestCreators,
  ...gtmSearchActionCreators,
  ...imageToutBlockActionCreators,
  ...postcodeActionCreators,
  ...requestServiceFormActionCreators,
  ...wysiwygActionCreators,
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/index-main.js